import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar/Navbar"; // ✅ ADD THIS
import Hero from "./components/Hero/Hero";
import Services from "./components/Services/Services";
import Banner from "./components/Banner/Banner";
import Subscribe from "./components/Subscribe/Subscribe";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Benefits from "./components/Services/Benefits";
import Features from "./components/Services/Features";
import PartyBoom from "./components/ballon&party/PartyBoom";
import { motion, AnimatePresence } from "framer-motion";
import DiwaliFireworkRain from "./components/ballon&party/DiwaliBurst";
import TrusterImages from "./components/Turster/TrusterImages";

const SplashScreen = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: 1.2 } }}
        className="fixed inset-0 z-[99999] flex items-center justify-center bg-black"
      >
        <img
          src="https://t4.ftcdn.net/jpg/09/24/14/05/360_F_924140594_YUjBubwd7VKcLTJgouLGGDoGoKUCxzUX.jpg"
          alt="Splash"
          className="absolute object-cover w-full h-full opacity-30"
        />

        <PartyBoom />
        <DiwaliFireworkRain />

        <div className="relative text-center px-4">
          <h1 className="text-white text-3xl md:text-5xl font-bold mb-4">
            WELCOME TO
            <span className="block text-yellow-400">
              NOBEL GURUKUL CONVENT SCHOOL & JUNIOR COLLEGE
            </span>
          </h1>

          <p className="text-white text-lg md:text-2xl opacity-90">
            Best education for your child's future
          </p>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

const App = () => {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <main className="overflow-x-hidden bg-white text-dark m-0 p-0">

      {showSplash ? (
        <SplashScreen onFinish={() => setShowSplash(false)} />
      ) : (
        <>
          {/* ✅ NAVBAR TOP */}
          <Navbar />

          {/* ✅ HERO BELOW */}
          <Hero />

          <Services />
          <Benefits />
          <Features />
          <Banner />
          <Subscribe />
          <TrusterImages />
          <Contact />
          <Footer />
        </>
      )}
    </main>
  );
};

export default App;